import { knbrHome } from './kn-br-home.i18n';

export const en = { knbrHome };
